import { render, staticRenderFns } from "./ChefCard.vue?vue&type=template&id=cc41eb6e&scoped=true&"
import script from "./ChefCard.vue?vue&type=script&lang=js&"
export * from "./ChefCard.vue?vue&type=script&lang=js&"
import style0 from "./ChefCard.vue?vue&type=style&index=0&id=cc41eb6e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc41eb6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VChip,VImg,VListItemContent})
